import React from 'react';
import { Button as ReactStrapButton } from 'reactstrap';
import '../../../styles/layout/forms/Button.css';


const Button =
    ({ children, className, disabled, onClick }) => {
        const getClassName = () => {
            if (className === undefined) {
                return 'theme-button';
            }
            return `theme-button ${className}`; 
        }
        return (
            <ReactStrapButton
                onClick={onClick}
                className={getClassName()}
                disabled = {disabled}
            >
                {children}
            </ReactStrapButton>
        )
    }

export default Button

